import { SVGProps } from "react"

const SearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" {...props}>
    <path
      d="M8.54163 13.25C9.83456 13.25 11.0745 12.7364 11.9888 11.8221C12.903 10.9079 13.4166 9.66793 13.4166 8.375C13.4166 7.08207 12.903 5.84209 11.9888 4.92785C11.0745 4.01361 9.83456 3.5 8.54163 3.5C7.2487 3.5 6.00872 4.01361 5.09448 4.92785C4.18024 5.84209 3.66663 7.08207 3.66663 8.375C3.66663 9.66793 4.18024 10.9079 5.09448 11.8221C6.00872 12.7364 7.2487 13.25 8.54163 13.25V13.25Z"
      stroke="#AEAFB4"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.2916 12.1249L15.6669 15.5001"
      stroke="#AEAFB4"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SearchIcon
